import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Pie } from '@ant-design/plots';
import { Link } from 'react-router-dom';
const RenewalVisualization = ({ data, flag, brand, model, country, result, keyFlag }) => {
    let totalCount = 0;
    let transformedData = [];
    let url = '';
    if (flag === 2 || 3) {
        const record = result.find((item) => (item === null || item === void 0 ? void 0 : item.intId) === keyFlag);
        transformedData =
            (record === null || record === void 0 ? void 0 : record.lstLuStatusCounts.filter((item) => item.intId !== 6010).map((item) => {
                var _a;
                return ({
                    type: item.strLongDesc || 'Unknown', // Provide fallback if strLongDesc is undefined
                    value: (_a = item.intStatusCount) !== null && _a !== void 0 ? _a : 0 // Provide fallback if intStatusCount is undefined
                });
            })) || [];
        totalCount = transformedData.reduce((sum, item) => sum + item.value, 0);
    }
    const config = {
        data: transformedData,
        angleField: 'value',
        colorField: 'type',
        radius: 0.8,
        innerRadius: 0.6,
        label: false,
        legend: false,
        color: ['#2389ff', '#0dcccc', '#f18e56', '#d787ff', '#7f6bff', '#68c738']
    };
    const generateDynamicUrl = (type) => {
        var _a, _b, _c, _d, _e;
        const formattedType = type.replace(/\s+/g, '-').toLowerCase();
        const queryParams = new URLSearchParams();
        const rId = (_a = result.find((item) => (item === null || item === void 0 ? void 0 : item.intId) === keyFlag)) === null || _a === void 0 ? void 0 : _a.lstLuStatusCounts.find(item => item.strLongDesc === type);
        if (brand)
            queryParams.append('brand', (_b = brand.strLongDesc) !== null && _b !== void 0 ? _b : '');
        if (model)
            queryParams.append('model', model);
        return `/certificates?key=${keyFlag !== null && keyFlag !== void 0 ? keyFlag : ''}&r=${(_c = rId === null || rId === void 0 ? void 0 : rId.intId) !== null && _c !== void 0 ? _c : ''}&b=${(_d = brand === null || brand === void 0 ? void 0 : brand.intId) !== null && _d !== void 0 ? _d : ''}&m=${model !== null && model !== void 0 ? model : ''}&c=${(_e = country === null || country === void 0 ? void 0 : country.intId) !== null && _e !== void 0 ? _e : ''}&q=${(flag !== null && flag !== void 0 ? flag : 1) - 1}`;
    };
    return (_jsxs(_Fragment, { children: [_jsx("h4", { style: { textAlign: 'center', marginBottom: '10px', color: '#333' }, children: _jsxs("i", { children: [totalCount, " Renewal Decided"] }) }), _jsxs("div", { style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '30px',
                    padding: '15px',
                    border: '1px solid #ccc',
                    borderRadius: '8px'
                }, children: [_jsx("div", { style: {
                            width: '200px',
                            height: '200px',
                            margin: '0',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }, children: _jsx(Pie, Object.assign({}, config)) }), _jsx("div", { style: { width: '50%' }, children: transformedData.length > 0 ? (transformedData.map((item, index) => (_jsxs("div", { style: {
                                marginBottom: '8px',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                width: '162px',
                                position: 'relative',
                            }, children: [_jsx("span", { style: {
                                        display: 'inline-block',
                                        width: '12px',
                                        height: '12px',
                                        backgroundColor: config.color[index],
                                        marginRight: '8px'
                                    } }), _jsxs(Link, { to: generateDynamicUrl(item.type), target: "_blank", style: {
                                        textDecoration: 'underline',
                                        color: config.color[index],
                                        pointerEvents: 'auto',
                                        display: 'flex',
                                        alignItems: 'center'
                                    }, children: [item.type, " (", item.value, ")"] })] }, index)))) : (_jsx("p", { children: "No data available" })) })] })] }));
};
export default RenewalVisualization;
